import classNames from 'classnames';
import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import styles from './TrailStandardCardShimmer.module.scss';

type TrailStandardCardShimmerProps = {
  className?: string;
};

const TrailStandardCardShimmer = ({ className }: TrailStandardCardShimmerProps) => (
  <ShimmerContainer className={classNames(styles.container, className)}>
    <div className={styles.image} />
    <div className={styles.long} />
    <div className={styles.medium} />
    <div className={styles.short} />
  </ShimmerContainer>
);

export default TrailStandardCardShimmer;
